export const DEFAULT_PRODUCT_TYPE_OPTIONS = [
  { value: "Arabica", label: "Arabica" },
  { value: "Robusta", label: "Robusta" },
  { value: "Blend", label: "Blend" },
  { value: "House Blend", label: "House Blend" },
  { value: "Liberika", label: "Liberika" },
  { value: "other", label: "Lainnya" },
];

export const DEFAULT_MATERIAL_TYPE_OPTIONS = [
  { value: "raw", label: "Raw" },
  { value: "roasted", label: "Roasted" },
  { value: "packaging", label: "Packaging" },
  { value: "Arabica", label: "Arabica" },
  { value: "Robusta", label: "Robusta" },
  { value: "Blend", label: "Blend" },
  { value: "other", label: "Lainnya" },
];

export const toTypeOptions = (types = [], fallbackOptions = [], category = "") => {
  if (!Array.isArray(types) || types.length === 0) return fallbackOptions;

  const filteredTypes = category
    ? types.filter((type) => type.category_value === category || type.category === category)
    : types;

  if (filteredTypes.length === 0) return category ? [] : fallbackOptions;

  return filteredTypes.map((type) => ({
    value: type.value,
    label: type.label || type.name || type.value,
    category_id: type.category_id,
    category_value: type.category_value,
    category_label: type.category_label,
  }));
};
